export const Svg_092 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M5.833 61.25V8.75h28.438v12.031h29.895v24.792h-4.374V25.156H34.27v7.657h5.833v4.374h-5.833v7.657h5.833v4.375h-5.833v7.656h14.218v4.375H5.833Zm4.375-4.375h7.656v-7.656h-7.656v7.656Zm0-12.031h7.656v-7.657h-7.656v7.657Zm0-12.032h7.656v-7.656h-7.656v7.657Zm0-12.03h7.656v-7.657h-7.656v7.656ZM22.24 56.874h7.657v-7.656h-7.657v7.656Zm0-12.031h7.657v-7.657h-7.657v7.657Zm0-12.032h7.657v-7.656h-7.657v7.657Zm0-12.03h7.657v-7.657h-7.657v7.656Zm37.042 46.301V60.74h-6.417v-4.375h6.417v-6.417h4.375v6.417H70v4.375h-6.344v6.343h-4.375Zm-11.52-29.895v-4.376h4.374v4.376H47.76Zm0 12.03v-4.374h4.374v4.375H47.76Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={20.672}
        x2={47.13}
        y1={17.5}
        y2={64.602}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)